import type { FaireProductEntity } from "../../entity_types/product";

export const p_x2b3hwubuf: FaireProductEntity = {
  token: "p_x2b3hwubuf",
  type: "product",
  name: "Kuromi Decorative Display Brick Building Set Hello Kitty",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/008a60b8a0f16ee40335d462b365fde1d387f7156f01704a1f0abafbf061ed17.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/39ab9d7bf082612af418efa1b63f15ff961a3c7d8983ada854ded1f4301f1dc5.jpeg",
    "https://cdn.faire.com/fastly/4b738b27c0a9f05e4d758eb04e637dc0bd75c61ce6131c410032725049586664.jpeg",
    "https://cdn.faire.com/fastly/d7a1ace50ef89ec1532fe6e074292e599dc099a6642627994ac359a6b83ad779.jpeg",
    "https://cdn.faire.com/fastly/3cb4ed946df68e4ffb54d845375fdc99b5e54746781eb20dfbfffb07e69ecd06.jpeg",
    "https://cdn.faire.com/fastly/6e1107f43c0d25779981425595d3ff959712df8ee439bd8499cc31bf8483a7b2.jpeg",
    "https://cdn.faire.com/fastly/330c93ef239d6fac1e0de0ddd196000b0c0397319b5f0510ece0e114747688ed.jpeg",
    "https://cdn.faire.com/fastly/2e537f133bb393b3b70d8ef1e4fe14e47aaf5d45bf7c6c3a75f5926d9ceee728.jpeg",
  ],
  priceDollars: 12.4,
  description:
    "Kuromi shows off her mischievous holiday style in this brick-built decoration featuring her black jester hood, pink skull emblem, and festive holiday lights. Printed eyes and cheeks capture her bold expression, while a striped scarf and nameplate base complete the design. With a stand and hanging string included, this playful build can be displayed on a desk, mantel, or holiday tree, bringing Sanrio’s cheekiest character into your seasonal décor.",
  tags: [],
  msrpDollars: 24.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:57.005Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
